<template>
  <div class="Introduction">
    <header>
      <h2 class="title">运动项目介绍</h2>
      <div class="header_right">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="1"><a href="#/">首 页</a></el-menu-item>
          <el-menu-item index="2">项目介绍</el-menu-item>
        </el-menu>
        <svg t="1623678502672" class="icon" viewBox="0 0 1026 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
             p-id="2624" width="61" height="61">
          <path
              d="M906.70592 507.33568c-44.40576 5.32992-355.24096-46.1824-490.22976-35.52256-39.07584 8.8832-229.13024 62.16704-333.9264 163.40992C66.56 621.00992 39.92064 587.264 18.60608 564.1728c39.07584-21.31456 465.36704-383.66208 980.46464-284.19072-5.32992 7.10656-261.09952-31.96928-461.81376 85.25824 21.31456 5.32992 271.75936 23.0912 390.76352 21.31456 28.42112-3.55328 67.49696-7.10656 85.25824-56.83712 5.32992 30.19264-26.64448 134.9888-106.5728 177.61792zM246.00064 344.064c68.05504-64.5632 142.0544-120.92416 142.0544-120.92416L317.0048 230.2464S254.83776 153.87136 245.95456 137.8816C340.096 65.05984 569.0368 1.3056 544.3584 17.1008c-44.40576 28.42112-85.25824 63.94368-120.7808 92.3648 55.06048-17.76128 177.61792 7.10656 177.61792 7.10656s40.85248 60.3904 63.94368 99.46624C441.33888 239.12448 110.96576 486.02112 110.96576 486.02112S175.54944 410.90048 246.00064 344.064zM594.09408 1018.88c-17.76128-3.55328-225.57696-90.58816-319.7184-305.50528 24.86784-17.76128 133.21728-74.5984 177.61792-85.25824-30.19776-12.43136-97.6896-47.95904-333.9264 0-33.79712 6.8608 246.89152-152.7552 554.17344-49.73568-8.8832 10.65472-191.83104 94.13632-269.98272 213.1456 10.65472 12.43136 143.872 87.03488 277.08928 120.7808-17.75616 24.86784-67.49184 87.03488-85.25312 106.5728z"
              p-id="2625" fill="#1296db"></path>
        </svg>
      </div>
    </header>
    <full-page ref="fullpage" :options="options" id="fullpage">
      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会冰上项目</div>
          <div class="div2">一、 冰壶</div>
          <div class="div3">
            冰壶，两队之间比赛，每队四人，两队轮流掷球，不仅需要使冰壶准确到达营垒的中心，同时让对方的冰壶远离圆心，最后以冰壶距离营垒圆心的远近决定胜负。冰壶1998年正式列入冬奥会比赛项目。
            比赛场地：国家游泳中心
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19171958-4303.jpg">
        </div>
      </div>
      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会冰上项目</div>
          <div class="div2">二、 冰球</div>
          <div class="div3">
            冰球亦称冰上曲棍球，是多变的滑冰技艺和敏捷娴熟的曲棍球技艺相结合，对抗性较强的集体冰上运动项目之一。运动员穿着冰鞋，手拿冰杆滑行拼抢击球，运动员用冰杆将球击入对方球门，以进球多者为胜。
            比赛场地：五棵松体育中心、国家体育馆
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19171958-4305.jpg">
        </div>
      </div>
      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会冰上项目</div>
          <div class="div2">三、 花样滑冰</div>
          <div class="div3">
            花样滑冰起源于18世纪的英国，后相继在德国、美国、加拿大等欧美国家迅速开展。1872年奥地利首次举办花样滑冰比赛，1924年被列为首届冬奥会比赛项目。
            比赛场地：首都体育馆
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19171959-4310.jpg">
        </div>
      </div>
      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会冰上项目</div>
          <div class="div2">四、 速度滑冰</div>
          <div class="div3">
            速度滑冰简称速滑，滑冰运动中历史最为悠久，开展最为广泛的项目。1763年2月4日在英国首次举行15公里速度滑冰赛。1889年在荷兰的阿姆斯特丹首次举办世界冠军赛。男、女速滑分别于1924年、1960年被列为冬奥会比赛项目。
            比赛场地：国家速滑馆
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19171959-4314.jpg">
        </div>
      </div>
      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会冰上项目</div>
          <div class="div2">五、 短道速滑</div>
          <div class="div3">
            短道速滑于1905/06年起源于加拿大和美国，1992年被列为冬奥会比赛项目。
            比赛场地：首都体育馆
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19172000-4318.jpg">
        </div>
      </div>
      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会雪上项目</div>
          <div class="div2">一、 雪橇</div>
          <div class="div3">
            雪橇起源于北欧，据记载，早在1480年挪威就已出现雪橇。1883年瑞士在达沃斯举行了世界上第一次雪橇比赛，1964年雪橇在第九届冬季奥运会中被列为正式比赛项目。
            比赛场地：国家雪车雪撬中心
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19172000-4324.jpg">
        </div>
      </div>
      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会雪上项目</div>
          <div class="div2">二、 跳台滑雪</div>
          <div class="div3">
            跳台滑雪起源于挪威，1860年挪威德拉门地区的两位农民在奥斯陆举行的首届全国滑雪比赛上表演了飞跃动作，后逐渐成为独立项目并得到广泛开展。19世纪末，跳台滑雪先后传入瑞典、瑞士、美国、法国、意大利和波兰等地。1924年被列入首届冬季奥运会比赛项目。
            比赛场地：北欧两项和冬季两项中心
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19172000-4328.jpg">
        </div>
      </div>
      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会雪上项目</div>
          <div class="div2">三、 钢架雪车</div>
          <div class="div3">
            钢架雪车在19世纪发源于瑞士山区的小城圣莫里茨，第一次的钢架雪车俯式冰橇比赛在1884年举行。1887年开始出现类似现在这种俯卧式的姿势。钢架雪车2002年盐湖城冬奥会被列为冬奥会正式比赛项目。
            比赛场地：国家雪车雪橇中心
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19172001-4332.jpg">
        </div>
      </div>
      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会雪上项目</div>
          <div class="div2">四、自由式滑雪</div>
          <div class="div3">
            自由式滑雪始于20世纪60年代，在高山滑雪基础上发展而成。1971年在美国新罕布什尔州举行世界上第一次正式的自由式滑雪比赛，1992年正式被列为冬奥会比赛项目。
            比赛场地：云顶滑雪公园
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19172001-4336.jpg">
        </div>
      </div>
      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会雪上项目</div>
          <div class="div2">五、 高山滑雪
          </div>
          <div class="div3">
            高山滑雪起源于欧洲的阿尔卑斯地区，故又称阿尔卑斯滑雪。高山滑雪是在越野滑雪基础上逐步形成的，1936年起被列为冬奥会比赛项目。
            比赛场地：国家高山滑雪中心
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19172001-4337.jpg">
        </div>
      </div>
      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会雪上项目</div>
          <div class="div2">六、 越野滑雪</div>
          <div class="div3">
            越野滑雪借助滑雪用具，运用登山、滑降、转弯、滑行等基本技术，滑行于山丘雪原的运动项目。起源于北欧，又称北欧滑雪，是世界运动史上最古老的运动项目之一。1924年被列入首届冬奥会比赛项目。
            比赛场地：北欧两项和冬季两项中心
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19172002-4341.jpg">
        </div>
      </div>
      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会雪上项目</div>
          <div class="div2">七、 单板滑雪</div>
          <div class="div3">
            单板滑雪源于20世纪60年代中期的美国，其产生与滑板和冲浪运动有关。1983年起举办世界锦标赛，1998年长野冬奥会被列为正式比赛项目。
            比赛场地：云顶滑雪公园
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19172002-4344.jpg">
        </div>
      </div>

      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会雪上项目</div>
          <div class="div2">八、 冬季两项</div>
          <div class="div3">
            冬季两项起源于斯堪的纳维亚半岛，由远古时代的滑雪狩猎演变而来。1924年被列为首届冬奥会表演项目，1960年被列为冬奥会比赛项目，并定名为冬季两项。
            比赛场地：北欧两项和冬季两项中心
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19172003-4352.jpg">
        </div>
      </div>
      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会雪上项目</div>
          <div class="div2">九、 雪车</div>
          <div class="div3">
            雪车起源于瑞士，由雪橇发展而来，1924年法国夏蒙尼第一届冬季奥运会中即被列为正式比赛项目。雪车用金属制成，形如小舟，车首覆有流线型罩，因此也得名“雪地之舟”。
            比赛场地：国家雪车雪橇中心
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19172003-4355.jpg">
        </div>
      </div>
      <div class="section">
        <div class="mainBox">
          <div class="div1">冬奥会雪上项目</div>
          <div class="div2">十、 北欧两项</div>
          <div class="div3">
            北欧两项起源于北欧，由越野滑雪和跳台滑雪组成，在挪威瑞典流传很长时间，成为北欧传统项目。1883年被列入霍尔门科伦滑雪大奖赛，20世纪初开始向世界推广，1924年被列为首届冬季奥运会比赛项目。
            比赛场地：北欧两项和冬季两项中心
          </div>
          <img alt="img" width="" src="http://img.coozhi.com/upload/image/201912/19172003-4357.jpg">
        </div>
      </div>
    </full-page>
    <div class="upBtn" @click="Refresh">
      <i class="el-icon-caret-top"></i>
      UP
    </div>
  </div>

</template>

<script>
export default {
  name: "Introduction",
  data() {
    return {
      activeIndex: '2',
      // options: {
      //   menu: '#menu',
      //   anchors: ['page1', 'page2', 'page3'],
      //   // sectionsColor: ['#41b883', '#ff5f45', '#0798ec']
      // }
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    Refresh () {
      location.reload();
    }
  }
}
</script>

<style lang="less" scoped>
html, body {
  margin: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  //top: -20%;
}

.Introduction {
  background-color: #edf2f6;
  top: -10px;
  .upBtn{
    position: fixed;
    bottom: 15%;
    right: 6%;
    cursor: pointer;
    &:hover{
      color: #02a6b5;
    }
  }
}

header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 3px;
  position: fixed;
  //top: 20px;
  z-index: 10;

  h2 {
    font-size: 1.9rem;
    font-weight: bold;
    font-family: 微软雅黑, serif;
    //color: #ffffff;
    margin: 10px;
    text-indent: 1em;
  }

  .header_right {
    position: relative;
    //width: 30%;
    right: 3%;
    display: flex;

    .el-menu {
      padding: 0 10px;

      a {
        text-decoration: none;
      }
    }

    svg {
      padding: 0 10px;
    }
  }
}

.mainBox {
  position: relative;
  background-color: #ffffff;
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
  0 6.7px 5.3px rgba(0, 0, 0, 0.028),
  0 12.5px 10px rgba(0, 0, 0, 0.035),
  0 22.3px 17.9px rgba(0, 0, 0, 0.042),
  0 41.8px 33.4px rgba(0, 0, 0, 0.05),
  0 100px 80px rgba(0, 0, 0, 0.07);
  margin: 0 auto;
  width: 55%;
  height: 80%;
  top: 12%;
  padding: 10px 15px 5px 15px;
  overflow: hidden;

  .div1 {
    font-size: 1.25rem;
    font-weight: bold;
    font-family: 微软雅黑, serif;
    position: relative;
    top: 10px;
    line-height: 52px;
    margin-bottom: 15px;
    border-bottom: 1px solid #dedede;
  }

  .div2 {
    font-family: 微软雅黑, serif;
    font-weight: 500;
    margin-top: 20px;
  }

  .div3 {
    font-family: 微软雅黑, serif;
    font-weight: normal;
    text-indent: 2em;
    margin-top: 20px;
  }

  img {
    //max-width: 920px;
    text-align: center;
    margin: 18px auto 0 auto;
    display: block;
    width: 90%;
  }
}
</style>